"use client"

// src/components/atoms/FileUpload.jsx
import { useState } from "react"
import api from "../../services/api"

const FileUpload = ({ onUpload }) => {
  const [uploading, setUploading] = useState(false)
  const [fileName, setFileName] = useState("")

  const handleFileChange = async (e) => {
    const file = e.target.files[0]
    if (!file) return
    setUploading(true)
    setFileName(file.name)
    try {
      const formData = new FormData()
      formData.append("file", file)
      // POST to /api/upload
      const res = await api.post("/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      onUpload(res.data.url)
    } catch (err) {
      console.error("File upload failed:", err)
      onUpload(null)
    } finally {
      setUploading(false)
    }
  }

  return (
    <div className="w-full">
      <div className="flex items-center justify-center w-full">
        <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer bg-gray-50 border-gray-300 hover:bg-gray-100 transition-colors duration-200">
          <div className="flex flex-col items-center justify-center pt-5 pb-6">
            <svg
              className="w-8 h-8 mb-3 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              ></path>
            </svg>
            <p className="mb-1 text-sm text-gray-500">
              <span className="font-semibold">Click to upload</span> or drag and drop
            </p>
            <p className="text-xs text-gray-500">SVG, PNG, JPG or GIF</p>
          </div>
          <input type="file" className="hidden" onChange={handleFileChange} />
        </label>
      </div>
      {uploading && (
        <div className="mt-2 flex items-center justify-center">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-amber-600 mr-2"></div>
          <p className="text-sm text-gray-600">Uploading...</p>
        </div>
      )}
      {fileName && !uploading && (
        <div className="mt-2 flex items-center">
          <svg
            className="w-5 h-5 text-green-500 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
          <p className="text-sm text-gray-700 truncate max-w-xs">{fileName} uploaded</p>
        </div>
      )}
    </div>
  )
}

export default FileUpload
